// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fQ-z","inlineTitle":"gQ-z","sponsoredAdsWrapper":"hQ-z","marketplaceRecosWrapper":"iQ-z"};